import React, { useState } from "react";
import { Card, Button, Row, Col } from "react-bootstrap";
import { FiServer } from "react-icons/fi";
import { FaCheckCircle } from "react-icons/fa";
import { FiSettings } from "react-icons/fi";

export default function StorageUsageCard() {

  const [active, setActive] = useState("1Y");
  const [hoverIndex, setHoverIndex] = useState(null);

  const data = {
    "1D": [50, 40, 30, 20, 25, 45],
    "7D": [120, 110, 80, 40, 60, 100],
    "1M": [200, 180, 120, 60, 90, 150],
    "1Y": [280, 260, 140, 68, 120, 260],
  };

  const labels = ["HR","Payroll","Attendance","Recruitment","Leaves","Document"];

  return (
    <Card style={styles.card}>
      <Card.Body>

        {/* HEADER */}
        <div style={styles.header}>
          <strong style={styles.title}>
            <FiServer style={{marginRight:6,color:"#f2540b"}}/>
            Storage Usage By Module (GB)
          </strong>

          <div>
            {["1D","7D","1M","1Y"].map(item=>(
              <Button
                key={item}
                onClick={()=>setActive(item)}
                style={{
                  ...styles.filterBtn,
                  background: active===item ? "#0d3b45" : "#eee",
                  color: active===item ? "#fff" : "#333"
                }}
              >
                {item}
              </Button>
            ))}
          </div>
        </div>

        {/* GRAPH */}
        <div style={styles.graph}>

          {data[active].map((val,i)=>{

            const height = val/2.6;

            return(
              <div
                key={i}
                style={styles.barWrapper}
                onMouseEnter={()=>setHoverIndex(i)}
                onMouseLeave={()=>setHoverIndex(null)}
              >

                {/* TOOLTIP */}
                {hoverIndex===i && (
                  <div style={styles.tooltip}>
                    <div style={{fontWeight:600}}>{labels[i]}</div>
                    <div style={styles.tooltipRow}>
                      <span style={styles.dot}></span>
                      Storage: {val}
                    </div>
                  </div>
                )}

                {/* SHADOW BAR */}
                <div style={styles.shadowBar}></div>

                {/* MAIN BAR */}
                <div
                  style={{
                    ...styles.bar,
                    height:height,
                    background:
                      labels[i]==="Attendance"
                        ? "#f2540b"
                        : "#2f5f6c"
                  }}
                >
                  {val} GB
                </div>

                <p style={styles.label}>{labels[i]}</p>

              </div>
            )
          })}

        </div>

        {/* STATUS CARDS */}
        <Row className="mt-3">
          {statusData.map((item,i)=>(
            <Col md={4} sm={6} xs={12} key={i} className="mb-3 ">
              <Card className="p-0" style={styles.innerCard}>
                <Card.Body className="p-3">

                  <p  className="p-0 m-1" style={styles.small}>{item.title}</p>

                  <div className="p-0 m-0" style={styles.statusRow}>
                    <strong>{item.value}</strong>

                    {item.type==="success"
                      ? <FaCheckCircle color="green"/>
                      : <FiSettings color="red"/>
                    }

                  </div>

                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>

      </Card.Body>
    </Card>
  );
}

const statusData = [
  { title:"Hr", value:"Uptime: 99.9%", type:"success"},
  { title:"Payroll Engine", value:"Uptime: 96.9%", type:"success"},
  { title:"Attendance Sync", value:"Uptime: 99.9%", type:"success"},
  { title:"Recruitment Module", value:"Downtime: 19.9%", type:"danger"},
  { title:"Leave Management", value:"Uptime: 91.9%", type:"success"},
  { title:"Document Storage", value:"Uptime: 95.9%", type:"success"},
];

const styles={

  card:{
    borderRadius:5,
    border:"2px solid #eee"
  },

  header:{
    display:"flex",
    justifyContent:"space-between",
    alignItems:"center",
    flexWrap:"wrap"
  },

  title:{
    fontWeight:650,
      fontSize:17

  },

  filterBtn:{
    border:"none",
    marginLeft:6,
    padding:"4px 12px",
    borderRadius:6,
    fontSize:12
  },

  graph:{
    display:"flex",
    justifyContent:"space-between",
    alignItems:"flex-end",
    marginTop:50,
    flexWrap:"wrap"
  },

  barWrapper:{
    position:"relative",
    textAlign:"center",
    flex:1,
    minWidth:90,
    height:240
  },

  shadowBar:{
    position:"absolute",
    bottom:33,
    left:"50%",
    transform:"translateX(-50%)",
    width:"65%",
    height:180,
    background:"#e9ecef",
    borderRadius:"7px",
    zIndex:1
  },

  bar:{
    position:"absolute",
    bottom:33,
    left:"50%",
    transform:"translateX(-50%)",
    width:"65%",
    borderRadius:"7px 7px 7px 7px",
    display:"flex",
    alignItems:"center",
    justifyContent:"center",
    color:"#fff",
    fontSize:13,
    fontWeight:"600",
    padding:"6px",
    minHeight:"70px",
    zIndex:2
  },

  label:{
    position:"absolute",
    bottom:0,
    width:"100%",
    fontSize:13,
    color:"#666"
  },

  tooltip:{
    position:"absolute",
    top:-45,
    left:"50%",
    transform:"translateX(-50%)",
    background:"#fff",
    padding:"8px 12px",
    borderRadius:6,
    boxShadow:"0 3px 12px rgba(0,0,0,0.2)",
    fontSize:12,
    zIndex:10
  },

  tooltipRow:{
    display:"flex",
    alignItems:"center",
    marginTop:1
  },

  dot:{
    width:8,
    height:8,
    borderRadius:"50%",
    background:"#2f5f6c",
    marginRight:6
  },

  innerCard:{
    background:"#f8f8f8",
    borderRadius:8
  },

  small:{
    fontSize:13,
    color:"#666"
  },

  statusRow:{
    display:"flex",
    justifyContent:"space-between",
    alignItems:"center",
    
  }

};